import { QueryClient } from '@tanstack/react-query';

/** Single client so login/logout can clear tenant-scoped React Query cache. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
